import React from 'react';

const DateSelect = ({ value, onChange, className, required }) => {
  const handleChange = (e) => {
    const { value: dateStr } = e.target;
    onChange(dateStr || '');
  };

  return (
    <input 
      type="date" 
      value={value || ''} 
      onChange={handleChange}
      className={className}
      required={required}
      max={new Date().toISOString().split('T')[0]}
    />
  );
};

export default DateSelect;